import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { type Thema, themas as allThemas } from '@/foundations/helpers/themas';


export default /*#__PURE__*/_defineComponent({
  __name: 'ThemaDialog',
  emits: ['themaPicked'],
  setup(__props, { emit: emits }) {



const selectedThema = ref<string>('');
const currentThemaList = ref<Thema[]>([]);

const dialog = ref<boolean>(false);

const initializeThemaList = () => {
  currentThemaList.value = allThemas.filter((t) => t.CodeValue.length === 1);
};

initializeThemaList();

const updateSelectedThema = (newThema: string) => {
  const newThemaList = allThemas
    .filter((t) => t.CodeValue.length === newThema.length + 1)
    .filter((t) => t.CodeValue.startsWith(newThema));
  if (newThemaList.length === 0) {
    return;
  }
  currentThemaList.value = newThemaList;
  selectedThema.value = newThema;
};

const previousThema = () => {
  updateSelectedThema(selectedThema.value.slice(0, -1));
};

const closeMenu = () => {
  dialog.value = false;
  updateSelectedThema('');
};

const addThema = (t: string) => {
  emits('themaPicked', t);
  closeMenu();
};

return { __sfc: true,emits, selectedThema, currentThemaList, dialog, initializeThemaList, updateSelectedThema, previousThema, closeMenu, addThema }
}

})